import { createFileRoute } from "@tanstack/react-router";
import { CursosSector } from "@/components/cursos-sector";

const TITLE = "Cursos para Empresas de Energía | Capacitación Empresas | Mine Class";
const DESCRIPTION =
  "Capacitación online corporativa para empresas de energía: seguridad eléctrica, bloqueo y etiquetado, trabajos en altura y acreditación de contratistas.";

export const Route = createFileRoute("/cursos/empresas/energia")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: "https://mine-class.com/cursos/empresas/energia" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESCRIPTION },
    ],
    links: [{ rel: "canonical", href: "https://mine-class.com/cursos/empresas/energia" }],
  }),
  component: () => <CursosSector sector="energia" />,
});
